import { render, staticRenderFns } from "./StructureList.vue?vue&type=template&id=3fa76c2f&scoped=true&"
import script from "./StructureList.vue?vue&type=script&lang=js&"
export * from "./StructureList.vue?vue&type=script&lang=js&"
import style0 from "./StructureList.vue?vue&type=style&index=0&id=3fa76c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa76c2f",
  null
  
)

export default component.exports